import { useState } from "react"

export const PropertyInquiriesState = () => {
	const [prptyInqrs, setPrptyInqrs] = useState({
        list: [],
        loader: false,
    }) 
	const [confirmation, setConfirmation] = useState({
        isIndoorFacOpen: false,
        indoorLoader: false,
        isOutdoorFacOpen: false,
        outdoorLoader: false,
        publishConfirmation: false,
        hasInvalidInputs: false,
        loader: false,
        statusConfirmation: false,
        statusLoader: false,
        listUpdatingLoader: false,
        isListUpdated: false,
        soldConfirmation: false,
        soldUpdatingLoader: false,
        isSoldUpdated: false,
    });
	const [status, setStatus] = useState({
        statusId: "",
        statusData: "",
        isStatusUpdated: false,
    })
	const statusStyles = {
        'For Inquiry': { bgcolor: '#e3f2fd', color: '#0d47a1' },
        'Declined': { bgcolor: '#ffebee', color: '#b71c1c' },
        'Approved': { bgcolor: '#e8f5e9', color: '#1b5e20' },
        'Appointment Scheduled': { bgcolor: '#fff3e0', color: '#e65100' },
        'Appointment Completed': { bgcolor: '#ede7f6', color: '#4a148c' },
        'Appointment Cancelled': { bgcolor: '#fbe9e7', color: '#bf360c' },
        'Requirements Saved': { bgcolor: '#e3f2fd', color: '#1565c0' },
        'Deal Closed': { bgcolor: '#d7ccc8', color: '#4e342e' },
        'Unknown Status': { bgcolor: '#eeeeee', color: '#616161' }
    };
	const [appntmntForm, setAppntmntForm] = useState({
        date: { value: '', stat: false, msg: 'Date is required!' },
        time: { value: '', stat: false, msg: 'Time is required!' },
        reason_for_cancelled: { value: '', stat: false, msg: 'Reason is required!' },
    })
	const [inquiryForm, setInquiryForm] = useState({
        status: { value: 1, stat: false, msg: 'Status is required!' },
        description: { value: '', stat: false, msg: 'Description is required!' },
        reason_for_rejection: { value: '', stat: false, msg: 'Reason is required!' },
    })
	const [fileTypes, setFileTypes] = useState({
        loader: false,
        userType: 1,
        fileType: 0,
        reqs: [],
        sellerAvailReq: [],
        buyerAvailReq: [],
        existing_file_reqs: '',
    });
	const [requirements, setRequirements] = useState({
        avail_reqs: [],
        match_reqs: [],
        modal: false,
        loader: false,
        sendLoader: false,
        sendSuccess: false,
        modalType: '',
        error: false,
    })
	const [inquiryData, setInquiryData] = useState({
        data: [],
        loader: false,
        modal: false,
        sendLoader: false,
        success: false,
        active: 1,
    })
	const statuses = [
        { id: 1, name: 'For Inquiry' }, 
        { id: 2, name: 'Declined' }, 
        { id: 3, name: 'Approved' }, 
        { id: 4, name: 'Appointment Scheduled' }, 
        { id: 5, name: 'Appointment Completed' },
        { id: 6, name: 'Appointment Cancelled' },
        { id: 7, name: 'Requirements Saved' },
        { id: 8, name: 'Deal Closed' },
    ]
	const [newReqName, setNewReqName] = useState({
        name: { value: '', stat: false, msg: 'Name is required!', exist: false, exist_msg: 'Requirement already exist!' },
        addReqModal: false,
        loader: false,
        success: false,
    })

	return {
		prptyInqrs: { data: prptyInqrs, set: setPrptyInqrs },
		confirmation: { data: confirmation, set: setConfirmation },
		status: { data: status, set: setStatus },
		statusStyles: { data: statusStyles },
		appntmntForm: { data: appntmntForm, set: setAppntmntForm },
		inquiryForm: { data: inquiryForm, set: setInquiryForm },
		fileTypes: { data: fileTypes, set: setFileTypes },
		requirements: { data: requirements, set: setRequirements },
		inquiryData: { data: inquiryData, set: setInquiryData },
		statuses: { data: statuses },
		newReqName: { data: newReqName, set: setNewReqName },
	}
}
